<template>
  <div>
    <FormSection>
      <SiteSelect v-model="order.site_uuid" :disabled="editMode" :companyUuid="order.company_uuid" required />
      <ZoneSelect
        v-model="order.origin_zone_uuid"
        :name="$t('orderForm.originZone')"
        :siteUuid="order.site_uuid"
        :disabled="!order.site_uuid || order.status != 'open'"
        required
      />
      <ContainerSelect
        v-model="order.full_container_uuid"
        :companyUuid="order.company_uuid"
        :selectedContainerName="order.full_container && order.full_container.name"
        @input="updateEmptyContainerAttributes"
        :name="$t('orders.fullContainer')"
        :disabled="!order.site_uuid || order.status != 'open'"
        :onlyAvailableForOrders="true"
        required
      />
      <ZoneSelect
        v-model="order.target_zone_uuid"
        :name="$t('orderForm.targetZone')"
        :siteUuid="order.site_uuid"
        :disabled="!order.site_uuid || order.status != 'open'"
        required
      />
    </FormSection>

    <FormSection :name="$t('orderForm.targetContainer')">
      <ContainerGroupTypeNameSelect
        v-model="order.target_container_type_group_name"
        required
        :disabled="order.status != 'open'"
      />
      <VolumeSelect v-model="order.target_container_type_volume" required :disabled="order.status != 'open'" />
      <FormInput
        :name="$t('meta.containerType')"
        v-model="order.target_container_type_name"
        :disabled="order.status != 'open'"
        :placeholder="$t('meta.containerType')"
      />
      <FractionSelect
        v-model="order.fraction_uuid"
        :companyUuid="order.company_uuid"
        :disabled="!order.site_uuid || order.status != 'open'"
        :selectableInOrders="true"
        required
      />
    </FormSection>

    <FormSection>
      <VehicleSelect
        v-model="order.vehicle_uuid"
        :companyUuid="order.company_uuid"
        :disabled="!order.site_uuid || order.status != 'open'"
      />
    </FormSection>

    <WeightSection v-model="order" v-if="editMode" />

    <InfoSection v-model="order" v-if="editMode" />
  </div>
</template>

<script>
import Vue from 'vue'

import FormInput from '@/components/Form/Input/index.vue'
import InfoSection from '@/components/Orders/forms/sections/InfoSection.vue'
import WeightSection from '@/components/Orders/forms/sections/WeightSection.vue'
import ContainerGroupTypeNameSelect from '@/components/Orders/forms/sections/elements/ContainerGroupTypeNameSelect.vue'
import ContainerSelect from '@/components/Orders/forms/sections/elements/ContainerSelect.vue'
import FractionSelect from '@/components/Orders/forms/sections/elements/FractionSelect.vue'
import SiteSelect from '@/components/Orders/forms/sections/elements/SiteSelect.vue'
import VehicleSelect from '@/components/Orders/forms/sections/elements/VehicleSelect.vue'
import VolumeSelect from '@/components/Orders/forms/sections/elements/VolumeSelect.vue'
import ZoneSelect from '@/components/Orders/forms/sections/elements/ZoneSelect.vue'
import stringUtils from '@/components/mixins/stringUtils'

import containersApi from '@/api/container'

export default {
  name: 'OrdersEmptyingForm',
  components: {
    ContainerGroupTypeNameSelect,
    ContainerSelect,
    FormInput,
    FractionSelect,
    InfoSection,
    SiteSelect,
    VehicleSelect,
    VolumeSelect,
    WeightSection,
    ZoneSelect,
  },
  mixins: [stringUtils],
  props: {
    value: { type: Object, required: true },
  },
  methods: {
    async updateEmptyContainerAttributes() {
      if (!this.order.full_container_uuid) return

      const fullContainer = await containersApi.get(this.order.full_container_uuid)

      Vue.set(this.order, 'target_container_type_group_name', fullContainer.type_container_type_group_name)
      Vue.set(this.order, 'target_container_type_name', fullContainer.type_name)
      Vue.set(this.order, 'target_container_type_volume', fullContainer.type_volume)
    },
  },
  computed: {
    editMode() {
      return !!this.order.uuid
    },
    order: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
  },
}
</script>
